import numeral from 'numeral';

numeral.register('locale', 'IDR', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'ribu',
    million: 'juta',
    billion: 'miliar',
    trillion: 'triliun',
  },
  ordinal (number) {
    return number;
  },
  currency: {
    symbol: 'Rp'
  }
});

numeral.register('locale', 'MYR', {
  delimiters: {
    thousands: ',',
    decimal: '.',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  ordinal (number) {
    return number;
  },
  currency: {
    symbol: 'RM',
  },
});

export default function(val, currency) {
  numeral.locale(currency);
  return numeral(val || 0);
}
